module.exports = __webpack_public_path__ + "img/2_216.794485a8.png";